// extracted by mini-css-extract-plugin
export var arrow = "_3l-6";
export var changeItem = "_3l-3";
export var changesHeader = "_3l-1";
export var changesList = "_3l-2";
export var container = "_3l-0";
export var pathLabel = "_3l-4";
export var value = "_3l-7";
export var valuesContainer = "_3l-5";